import React from "react";

import ariaLogo from "../../../svg/aria-university-logo.svg";
import awpLogo from "../../../img/awp-logo.png";

/** Default Aria crest for reports; pass variant="awp" for payment receipts. */
const PrintLogo = ({ variant = "aria" }) => {
  const logo = variant === "awp" ? awpLogo : ariaLogo;
  return (
    <div className={`logo${variant === "awp" ? " is-awp" : " is-aria"}`}>
      <img src={logo} alt="ARIA UNIVERSITY" />
      {variant === "awp" ? (
        <div className="print-header-separator" aria-hidden="true">
          <span className="line" />
          <span className="diamond" />
          <span className="line" />
        </div>
      ) : null}
    </div>
  );
};

export default PrintLogo;
